import React, { createContext, useEffect } from "react";
import { fetchAvailablePaymentPlatforms, setPayingItemId, setPaymentRelatedObjectType } from "../../actions/payment";
import Cookies from "js-cookie";
import { parseInt } from "lodash";
import { useAppDispatch, useAppSelector } from "@/hooks";


export const PaymentPlatformContext = createContext({});


/*
 * Feature component
 *
 * Responsible for rendering the payment dialog.
 *
 * - Handles the retrieval of availablePaymentPlatforms reducer actions.
 * - Transmits data to the paymentPlatforms components.
 * - Hides the dialog if the platformName is not available.
*/

interface IPaymentPlatformProviderProps {
  platformName?: string,
  onPaymentSuccessful?: (details: string) => void,
  onPaymentError?: (reason: string) => void,
  onClose?: () => void,
  children?: string | JSX.Element
}

const PaymentPlatformProvider = ({
  platformName="",
  onPaymentSuccessful,
  onPaymentError,
  onClose,
  children
}: IPaymentPlatformProviderProps) => {
  const dispatch = useAppDispatch();
  const availablePaymentPlatforms = useAppSelector(state => state.payment.availablePaymentPlatforms);
  const payingItemId = useAppSelector(state => state.payment.payingItemId);

  useEffect(() => {
    // When load verify if the url path has the a paymentIntentId, if so continue with the payment process
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntentId = urlParams.get("payment_intent");
    if (paymentIntentId) {
      let payingItemIdCookie = Cookies.get("payingItemId"); // Al fer el refresc es perd l'store
      if (!payingItemIdCookie) {
        Cookies.remove("payingItemId");
        Cookies.remove("paymentRelatedObjectType");
        // TODO: Afegir SENTRY, no és normal que tinguis url param de payment_intent i no tinguis la cookie de payingItemId, no podras seguir amb el pagamanet
      } else {
        if (payingItemId && payingItemId !== parseInt(payingItemIdCookie)) { // Cas rar, no hauries de tenir payintItemId al redux, ja que quan tenim paymentIntentId vol dir que han redirigit, per tant el redux store es reseted
          Cookies.remove("payingItemId");
          Cookies.remove("paymentRelatedObjectType");
          // TODO: Afegir SENTRY, si no tenim la mateixa paying item id entre el redux i la cookie és que algo no esta ben lligat
        } else {
          if (payingItemId !== parseInt(payingItemIdCookie)) { // Sempre entrara per aqui
            let paymentRelatedObjectType = Cookies.get("paymentRelatedObjectType"); // Al fer el refresc es perd l'store
            dispatch(setPayingItemId(parseInt(payingItemIdCookie)));
            dispatch(setPaymentRelatedObjectType(paymentRelatedObjectType));
          }
          // Es un intent i ha sigut redirigit Cal que obris el dialog de nou per acabar amb el pagament.
        }
      }
    }
  }, []);

  useEffect(() => {
    if (availablePaymentPlatforms === null) {
      dispatch(fetchAvailablePaymentPlatforms())
    }
  }, [availablePaymentPlatforms]);


  const handleClose = () => {
    dispatch(setPayingItemId(null));
    dispatch(setPaymentRelatedObjectType(null));
    onClose && onClose();
  }

  const handlePaymentSuccess = (details: string) => {
    //dispatch(receivePaySuccess(details["success"]));
    onPaymentSuccessful && onPaymentSuccessful(details);
  }

  const handlePaymentError = (reason: string) => {
    //dispatch(receivePayError(reason));
    onPaymentError && onPaymentError(reason);
  }

  const isPaymentPlatformAvailable = () => {
    if (platformName && !!availablePaymentPlatforms) {
      return availablePaymentPlatforms[platformName];
    } else {
      return false
    }
  }

  return (
    <PaymentPlatformContext.Provider value={{
      "handlePaymentSuccess": handlePaymentSuccess,
      "handlePaymentError": handlePaymentError,
      "onClose": handleClose,
      "platformName": platformName,
      "isPaymentPlatformAvailable": isPaymentPlatformAvailable
    }}>
      { children }
    </PaymentPlatformContext.Provider>
  )

};


export default PaymentPlatformProvider;
